import { FeatureFlagBanner } from './feature-flag-banner';

export default FeatureFlagBanner;
